import * as React from "react";
import type { SVGProps } from "react";
const SvgMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#money_svg__a)">
      <path d="M6.28 16.11c-1.22 0-2.34-.82-2.68-2.05L2.1 8.44c-.2-.71-.1-1.46.27-2.1s.97-1.1 1.68-1.29L15.08 2.1c1.48-.4 3 .48 3.39 1.96l1.5 5.61c.4 1.47-.48 3-1.96 3.39L6.98 16.02q-.36.09-.72.09zM15.8 4c-.07 0-.13 0-.2.03L4.57 6.98a.77.77 0 0 0-.47.36.8.8 0 0 0-.08.58l1.5 5.61c.11.41.54.65.94.54l11.03-2.96c.2-.05.36-.18.47-.36.1-.18.13-.39.08-.58l-1.5-5.61a.77.77 0 0 0-.74-.57z" />
      <path d="M3.58 11.1c-.44 0-.85-.29-.96-.74a.994.994 0 0 1 .71-1.22l14.44-3.87a.994.994 0 0 1 1.22.71.994.994 0 0 1-.71 1.22L3.84 11.07c-.09.02-.17.03-.26.03M19 22c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
      <path d="M14 20c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1M7.5 21a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5" />
    </g>
    <defs>
      <clipPath id="money_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMoney;
